// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 20) return "static/js/0334ee941159f353b20b.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"54756794370632fdfa86","118":"b51a3828c36a4ed09832","119":"59d85a301cafa328a836"}[chunkId] + ".chunk.js";
};